// components
import { useParams } from "react-router-dom";
import { FiAlertTriangle } from "react-icons/fi";
import RelatedProducts from "../components/RelatedProducts";
import Spinner from "../components/ui/Spinner";
import StateMessage from "../components/ui/StateMessage";
// context
import { CartContext } from "../context/CartContext";
import useFetch from "../hook/useFetch";
import { formatPrice } from "../lib/formatPrice";
import { useContext } from "react";

export default function ProductDetails() {
  const { addToCart } = useContext(CartContext);
  const { id } = useParams();
  const { data, isLoading, error } = useFetch(`/products/products?slug=${id}`);

  if (isLoading) {
    return (
      <div className="container mx-auto pt-44 lg:pt-[30px] xl:pt-0 min-h-[60vh] flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (error || !data || data.length === 0) {
    return (
      <div className="container mx-auto pt-44 lg:pt-[30px] xl:pt-0">
        <StateMessage
          icon={FiAlertTriangle}
          title="Product not found"
          message="This product may have been removed or is temporarily unavailable."
        />
      </div>
    );
  }

  const product = data[0];
  // category label for the header (category is populated on this endpoint)
  const categoryLabel = product.category?.title;

  return (
    <div className="mb-16 pt-44 lg:pt-[30px] xl:pt-0">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row gap-[30px] mb-[30px]">
          <div className="flex-1 lg:max-w-[40%] lg:h-[540px] grad rounded-card border border-border flex justify-center items-center">
            <img
              className="w-full max-w-[65%]"
              src={`${product.image}`}
              alt={product.title}
            />
          </div>
          <div className="flex-1 bg-surface border border-border p-12 xl:p-20 rounded-card flex flex-col justify-center">
            <div className="uppercase text-brand text-lg font-medium mb-2">
              {categoryLabel ? `${categoryLabel} cameras` : "Camera"}
            </div>
            <h2 className="h2 mb-4">{product.title}</h2>
            <p className="mb-12 text-muted">{product.description}</p>
            <div className="flex items-center gap-x-8">
              <div className="text-3xl text-ink font-semibold">
                {formatPrice(product.regularPrice)}
              </div>
              <button
                onClick={() => addToCart(product)}
                className="btn btn-accent">
                Add to cart
              </button>
            </div>
          </div>
        </div>
        <RelatedProducts categoryTitle={product.slug} />
      </div>
    </div>
  );
}
